import styled, { css } from 'styled-components';

import { Label } from '@r1-frontend/ui-react/components/label';
import { ICustomDotsStyles } from '@r1-frontend/ui-react/components/NukaCarousel/DefaultDots/styled';
import SlideCarousel from '@r1-frontend/ui-react/components/SlideCarousel';
import { BorderRadius } from '@r1-frontend/ui-react/tokens/borderRadius';
import { COLORS } from '@r1-frontend/ui-react/tokens/colors';

import Widget from '~/src/components/Widget';

export const CustomDotsStyles: ICustomDotsStyles = {
    dot: {
        background: COLORS.BgMain,
    },
    activeDot: {
        background: COLORS.BgMain,
    },
};

export const ImgCarousel = styled(SlideCarousel)`
    padding-bottom: 0;
    height: 100%;

    & > section > div.slider-control-bottomcenter {
        bottom: 10px !important;
    }

    & > section > div.slider-frame {
        height: 100% !important;

        & div {
            height: 100% !important;
        }

        & div.slider-slide {
            border-radius: ${BorderRadius.OuterBlockRadius} ${BorderRadius.OuterBlockRadius} 0 0;
            overflow: hidden;
        }
    }
`;

export const PackageImage = styled.img`
    width: 100%;
    height: 100%;
    object-position: center;
    object-fit: cover;
`;

export const PromoLabel = styled(Label)`
    margin-bottom: 4px;
`;

export const WidgetPrice = styled(Widget.Price)<{ isPromo: boolean }>`
    ${({ isPromo }) => isPromo && css`
        color: ${COLORS.LabelsText_2};
    `};
`;
